/* tslint:disable */

/**
 */
export class CategoryInput {
    style_search?: string;
    key_input?: string;
}
